import { useNavigationStore } from '@hb/react'
import { useCallback } from 'react'
import { NavigateOptions, To, useNavigate as useRRNavigate } from 'react-router'

export const useNavigate = () => {
  const rrNavigate = useRRNavigate()
  const setPendingNavigation = useNavigationStore(s => s.setPendingNavigation)

  return useCallback(
    (to: To | number, options?: NavigateOptions) => {
      const unsavedFormChange = useNavigationStore.getState().unsavedFormChange
      if (unsavedFormChange) {
        setPendingNavigation({
          formName: unsavedFormChange.formName,
          to: to as string | number,
          options: options as Record<string, unknown> | undefined,
        })
      } else {
        if (typeof to === 'number') {
          rrNavigate(to)
        } else {
          rrNavigate(to, options)
        }
      }
    },
    [rrNavigate, setPendingNavigation],
  )
}
